import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import RatingTable from "../RatingTable";
import { AddTalentReviewCandidate } from "../../../types/addReviewCandidate";

const TacticalAwarenessStep = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal" });
  const { t: tTalentReport } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal.talentReport" });

  const { control } = useFormContext<AddTalentReviewCandidate>();

  const tacticalAwareness: { title: string; description: string; fieldName: keyof AddTalentReviewCandidate }[] = [
    {
      title: tTalentReport("positioning"),
      description: tTalentReport("abilityToBeInTheRightPlace"),
      fieldName: "positioning",
    },
    {
      title: tTalentReport("offTheBallMovement"),
      description: tTalentReport("intelligentRunsCreatingSpace"),
      fieldName: "offTheBallMovement",
    },
    {
      title: tTalentReport("defensiveAwareness"),
      description: tTalentReport("markingTacklingAnticipating"),
      fieldName: "defensiveAwareness",
    },
    {
      title: tTalentReport("transitionPlay"),
      description: tTalentReport("speedAwareness"),
      fieldName: "transitionPlay",
    },
    {
      title: tTalentReport("spatialAwareness"),
      description: tTalentReport("useOfWidthDepthAngles"),
      fieldName: "spatialAwareness",
    },
    {
      title: tTalentReport("tacticalAdaptability"),
      description: tTalentReport("abilityToAdjust"),
      fieldName: "tacticalAdaptability",
    },
  ];

  return (
    <Box sx={[styles.container, styles.containerPadding]}>
      <RatingTable ratings={tacticalAwareness} control={control} />
    </Box>
  );
};

export default TacticalAwarenessStep;

const styles = {
  containerPadding: {
    px: "24px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
